import { render, staticRenderFns } from "./ExpandTableContent.vue?vue&type=template&id=55c82a45&"
import script from "./ExpandTableContent.vue?vue&type=script&lang=js&"
export * from "./ExpandTableContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports